import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
  AccordionHeader,
  AccordionHeaderText,
  FormController,
  MuiBox,
  MuiButtonPrimary,
  MuiRadioGroup,
} from "../../../../components";

import { useSiteCore } from "../../../../hooks/useSiteCore";
import { BulkEditProgramSelectionFormKey } from "../../modelsAndSchema/Model";
import { BulkEditProgramSiteCoreKeys } from "../../siteCore/siteCoreKeys";
import {
  BulkEditTypeSelectFooterWrapper,
  BulkEditTypeSelectWrapper,
} from "./BulkEditTypeSelect.style";

interface BulkEditTypeSelectProps {
  onContinue: (nextStep: number) => void;
}
const BulkEditTypeSelect: React.FC<BulkEditTypeSelectProps> = ({
  onContinue,
}) => {
  const { commonLabels, useFetchLabel, fetchComponentTitle, pageTitle } =
    useSiteCore();

  const getLabel = useFetchLabel(
    BulkEditProgramSiteCoreKeys.bulkProcessDetails,
  );

  const methods = useForm({
    defaultValues: {
      [BulkEditProgramSelectionFormKey.selectedType]: "0",
      [BulkEditProgramSelectionFormKey.downloadTemplate]: "",
      [BulkEditProgramSelectionFormKey.uploadTemplate]: "",
    },
  });

  const { control, setValue, getValues } = methods;

  const radioOptions = [
    {
      label: getLabel(BulkEditProgramSiteCoreKeys.chooseParticipants),
      value: "0",
    },
    {
      label: getLabel(BulkEditProgramSiteCoreKeys.uploadModifiedTemplate),
      value: "1",
    },
  ];

  const handleSearchTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    setValue(BulkEditProgramSelectionFormKey.selectedType, value);
  };
  const renderHeader = (label: string) => {
    return <AccordionHeaderText label={label} />;
  };

  const handleContinue = () => {
    const selected = getValues(BulkEditProgramSelectionFormKey.selectedType);
    onContinue(selected === "0" ? 1 : 2);
  };

  return (
    <FormProvider {...methods}>
      <BulkEditTypeSelectWrapper data-testid="bulk-edit-type-select">
        <AccordionHeader
          className="accordion-header"
          title={renderHeader(
            fetchComponentTitle(BulkEditProgramSiteCoreKeys.bulkProcessDetails),
          )}
          isExpanded={true}
        >
          <MuiBox className="radio-button-container">
            <FormController
              control={control}
              name={BulkEditProgramSelectionFormKey.selectedType}
            >
              <MuiRadioGroup
                label={getValues(BulkEditProgramSiteCoreKeys.selectType)}
                value={getValues(BulkEditProgramSelectionFormKey.selectedType)}
                onChange={handleSearchTypeChange}
                options={radioOptions}
                data-testid="selected-type"
                requiredARIALabel={""}
              />
            </FormController>
          </MuiBox>
        </AccordionHeader>
      </BulkEditTypeSelectWrapper>
      <BulkEditTypeSelectFooterWrapper>
        <MuiButtonPrimary onClick={handleContinue}>
          {commonLabels.continue}
        </MuiButtonPrimary>
      </BulkEditTypeSelectFooterWrapper>
    </FormProvider>
  );
};

export default BulkEditTypeSelect;
